import Vue from 'vue'
import App from './App.vue'
import router from './router'

import '@/assets/icons/index.js'
import download from '@/util/download.js'
Vue.prototype.$download = download

import common from '@/api/common'
import vdr from 'vue-draggable-resizable-gorkys'
import 'vue-draggable-resizable-gorkys/dist/VueDraggableResizable.css'
import directive from './directive' // directive
import plugins from './plugins' // plugins
import store from './store/index'

// 还是按照之前的写法一样写弹出框信息，但如果一直触发弹出框就只会提示一次，不会在页面堆叠
import { message } from '@/util/resetMessage'

import * as commonUtils from '@/util/ruoyi'

Object.keys(commonUtils).forEach(key => {
  Vue.prototype[key] = commonUtils[key]
})

import { getDicts } from '@/api/system/dict'
import axios from 'axios'
// 设置全局的settings
import settings from './settings'
Vue.prototype.$settings = settings

// 字典数据组件
import DictData from '@/components/DictData'

// //axios
import apiFun from '@/util/request.js'
Vue.prototype.$apiFun = apiFun //请求接口api
Vue.prototype.axios = axios

//引入element组件库
import '@/util/flexible.js'
import ElementUI, { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
Vue.prototype.$messageSingle = message
Vue.component('vdr', vdr)
Vue.prototype.getDicts = getDicts
Vue.prototype.getConfigKey = apiFun.getConfigKey
Vue.use(plugins)
Vue.use(directive)
Object.keys(common).forEach(key => {
  Vue.prototype[key] = common[key]
})
DictData.install()

// 防止连续点击
Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener(
      'click',
      e => {
        if (!el.disabled) {
          // el.disabled = true
          el.style.pointerEvents = 'none'
          setTimeout(() => {
            // el.disabled = false
            el.style.pointerEvents = 'auto'
          }, binding.value || 500)
        } else {
          // disabled为true时，阻止默认的@click事件
          e.preventDefault()
          e.stopPropagation()
        }
      },
      true
    )
  }
})

Vue.prototype.$message = function(msg, duration = 3000, showClose = false) {
  return Message({
    customClass: 'message-class',
    showClose,
    message: msg,
    duration,
    offset: 80,
    center: true
  })
}
//分别对success、warning和error等样式进行设置
Vue.prototype.$message.success = function(msg, duration = 3000, showClose = false) {
  return Message.success({
    customClass: 'message-class',
    showClose,
    message: msg,
    duration,
    offset: 80,
    center: true
  })
}
Vue.prototype.$message.warning = function(msg, duration = 3000, showClose = false) {
  return Message.warning({
    customClass: 'message-class',
    showClose,
    message: msg,
    duration,
    offset: 80,
    center: true
  })
}
Vue.prototype.$message.error = function(msg, duration = 3000, showClose = false) {
  return Message.error({
    customClass: 'message-class',
    showClose,
    message: msg,
    duration,
    offset: 80,
    center: true
  })
}
//引入moment
import moment from 'moment'
Vue.prototype.$moment = moment
moment.locale('zh-cn')

import introJs from 'intro.js'
import 'intro.js/introjs.css'
import 'intro.js/themes/introjs-modern.css' // introjs主题
Vue.prototype.$introJs = introJs

// 一个复制粘贴的插件
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

//引入fontawesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(fas, far)
Vue.component('font-awesome-icon', FontAwesomeIcon)
/*左边工具栏以及编辑节点的样式*/
import 'bpmn-js/dist/assets/diagram-js.css'
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn.css'
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn-codes.css'
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css'
///*右边工具栏样式*/
import 'bpmn-js-properties-panel/dist/assets/bpmn-js-properties-panel.css'
// 元素节点右侧工具栏的样式
import '@/views/warehouse/bpmn_flowSheet/custom/contextPad/index.scss'
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
